import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  Divider,
  InputAdornment,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import CompanyLists from "./CompanyLists";

const style = {
  searchField: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 2,
      backgroundColor: "#F3F3F3",
      "& .MuiOutlinedInput-notchedOutline": {
        border: `none`,
        boxShadow: "none",
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        border: `none`,
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: `none`,
      },
    },
  },
};

function AllUsers({ socket }) {
  const { t } = useTranslation(["common"]);
  return (
    <Paper sx={{ borderRadius: "10px", height: "100%" }}>
      {/* Header */}
      <Stack p={2} gap={1.5} direction={"row"} alignItems={"center"}>
        <ChatOutlinedIcon sx={{ color: "primary.main" }} />
        <Stack direction={"row"} alignItems={"center"}>
          <Typography variant="h1" fontSize={"1.125rem"} fontWeight={"bold"}>
            {t("messages")}
          </Typography>
          <ExpandMoreIcon />
        </Stack>
        {/* <Box
          p={"3px 6px"}
          bgcolor={"custom.softGrey"}
          borderRadius={"50%"}
          display={"flex"}
          alignItems={"center"}
          justifyContent={"center"}
        >
          <span
            style={{
              fontSize: "12px",
            }}
          >
            12
          </span>
        </Box> */}
      </Stack>
      <Divider />

      <Box m={1}>
        <TextField
          variant="outlined"
          sx={style.searchField}
          fullWidth
          placeholder={t("searchMessage")}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </Box>

      <CompanyLists socket={socket} />
    </Paper>
  );
}

export default AllUsers;
